import React, { Suspense } from 'react';
import { ThemeProvider } from '@mui/material';
import ErrorBoundary from '../providers/ErrorBoundary';
import LayoutProvider from '../providers/LayoutProvider';
import Loader from '../components/shared/Loader';
import Home from '../components/Home';
import theme from '../utils/theme';
import './globalStyles.css';

const App = () => (
  <LayoutProvider>
    <ErrorBoundary>
      <Suspense fallback={<Loader />}>
        <ThemeProvider theme={theme}>
          <Home />
        </ThemeProvider>
      </Suspense>
    </ErrorBoundary>
  </LayoutProvider>
);

export default App;
